import { compose, pure } from '../../../../src/web/utils/react';
import { editor, widget } from '../../../../src/web/components/widgets/decorators';
import StockIcons from './StockIcons';
import Editor from './Editor';
import { NAME, ID } from './properties';

export default compose(
  editor(Editor),
  pure(),
  widget(
    { name: NAME, category: 'Buttons / Icons', componentId: ID },
    {
      defaults: {
        icon: 'icon icon-dollie-handcarts',
        align: 'text-center',
        color: '',
        target: '_self',
      },
    },
  ),
)(StockIcons);
